import * as React from "react";
import {
  Show,
  useRedirect,
  useNotify,
  SimpleShowLayout,
  TextField,
  DateField,
  ImageField,
  BooleanField,
  TopToolbar,
  DeleteWithConfirmButton,
  EditButton,
} from "react-admin";
import BackButton from "../backButton";

const InfoShow = (props) => {
  const notify = useNotify();
  const redirect = useRedirect();

  const CustomShowActions = ({ basePath, data, resource }) => (
    <TopToolbar>
      <BackButton color="primary" style={{ marginLeft: "5rem" }} />
      <EditButton basePath={basePath} record={data} />
      {data ? (
        <DeleteWithConfirmButton
          undoable={false}
          onSuccess={onSuccess}
          onFailure={onFailure}
          basePath={basePath}
          record={data}
          resource={resource}
        />
      ) : (
        ""
      )}
    </TopToolbar>
  );

  const onSuccess = () => {
    notify(`Info deleted successfully`, `success`);
    redirect("/info");
  };

  const onFailure = (error) => {
    console.log(error);
    notify(`Info can not be delete`, `warning`);
    redirect("/info");
  };

  return (
    <Show {...props} actions={<CustomShowActions />}>
      <SimpleShowLayout>
        <TextField source="id" sortable={false} />
        <TextField
          source="button_text.en"
          sortable={false}
          label="Button Text For English"
        />
        <TextField
          source="button_text.tu"
          sortable={false}
          label="Button Text For Turkish"
        />
        <TextField source="button_url" sortable={false} label="Button Url" />
        <ImageField source="banner.en" sortable={false} />
        <ImageField source="banner.tu" sortable={false} />
        <ImageField source="mobile.en" sortable={false} />
        <ImageField source="mobile.tu" sortable={false} />
        <BooleanField source="isActive" sortable={false} />
        <DateField source="createdAt" sortable={false} />
      </SimpleShowLayout>
    </Show>
  );
};

export default InfoShow;
